import { render, staticRenderFns } from "./MhColorSelect.vue?vue&type=template&id=15e402c6&scoped=true&"
import script from "./MhColorSelect.vue?vue&type=script&lang=js&"
export * from "./MhColorSelect.vue?vue&type=script&lang=js&"
import style0 from "./MhColorSelect.vue?vue&type=style&index=0&id=15e402c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e402c6",
  null
  
)

export default component.exports